import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@pc/components/ui/skeleton';
function ChannelSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mx-auto w-[1360px] px-10"><Skeleton className="my-[18px] h-[28px] w-full" /><Skeleton className="my-[18px] h-[28px] w-full" /><Skeleton className="my-[18px] h-[480px] w-full" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default ChannelSkeleton;